import flatpickr from 'flatpickr';
(function ($) {
  'use strict';

  // Toggle header background on scroll
  function handleHeaderScroll() {
    const $headerMain = $('.header-main');
    if ($headerMain.length) {
      if ($(window).scrollTop() > 10) {
        $headerMain.removeClass('bg-transparent py-4').addClass('bg-white mshadow-md py-3');
        // change colors for text/links inside header if necessary
        $headerMain.find('.text-white').removeClass('text-white').addClass('text-stone-900 header-is-white');
        $headerMain.find('.border-white').removeClass('border-white').addClass('border-stone-900 border-is-white');
      } else {
        $headerMain.removeClass('bg-white mshadow-md py-3').addClass('bg-transparent py-4');
        $headerMain.find('.header-is-white').removeClass('text-stone-900 header-is-white').addClass('text-white');
        $headerMain.find('.border-is-white').removeClass('border-stone-900 border-is-white').addClass('border-white');
      }
    }
  }

  $(window).on('scroll', handleHeaderScroll);
  $(document).ready(handleHeaderScroll);


  // Đẩy data form lên CF7 (Dùng Arrow Function và Async/Await)
  const handleKavinetForm = async (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    const $form = $(form); // Vẫn dùng JQuery cho mấy cái DOM manipulation cho nhanh
    const responseDiv = form.querySelector('.form-response');
    const btn = form.querySelector('button[type="submit"]');

    const cf7Id = $form.data('formid');
    const endpoint = `/wp-json/contact-form-7/v1/contact-forms/${cf7Id}/feedback`;

    if (!cf7Id) {
      console.error('Kavinet Error: Data-formid is missing!');
      return;
    }

    // Hiệu ứng Loading (Dùng class của mày)
    btn.disabled = true;
    btn.classList.add('opacity-50');
    const originalText = btn.innerText;
    btn.innerText = 'Đang xử lý...';

    const formData = new FormData(form);
    formData.append('_wpcf7', cf7Id);
    formData.append('_wpcf7_unit_tag', `wpcf7-f${cf7Id}-p-v1`);

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        body: formData
      });

      const result = await response.json();

      // Reset nút
      btn.disabled = false;
      btn.classList.remove('opacity-50');
      btn.innerText = originalText;

      if (result.status === 'mail_sent') {
        responseDiv.innerHTML = '<span class="text-success fw-bold animate-fade-in">Gửi thành công! Cảm ơn sếp.</span>';
        form.reset();
      } else {
        // Xử lý lỗi validation chi tiết (nếu có)
        responseDiv.innerHTML = `<span class="text-danger">${result.message}</span>`;

        if (result.invalid_fields) {
          result.invalid_fields.forEach(field => {
            // Tìm đúng cái input bị lỗi (ví dụ: your-email)
            const input = form.querySelector(`[name="${field.field}"]`);
            if (input) {
              input.classList.add('border', 'border-danger'); // Thêm viền đỏ

              // Mẹo: Tự động xóa viền đỏ khi user bắt đầu gõ lại
              input.addEventListener('input', () => {
                input.classList.remove('border', 'border-danger');
              }, { once: true });
            }
          });
        }
      }
    } catch (error) {
      btn.disabled = false;
      btn.classList.remove('opacity-50');
      btn.innerText = originalText;
      responseDiv.innerHTML = '<span class="text-danger">Lỗi kết nối Server. Thử lại sau nhé!</span>';
    }
  };

  // Lắng nghe sự kiện (Tương thích tốt với Laravel Mix)
  document.querySelectorAll('.kavinet-ajax-form').forEach(form => {
    form.addEventListener('submit', handleKavinetForm);
  });

  // Flatpickr - Date picker cho form đặt phòng
  $(document).ready(function () {
    const today = new Date();

    const checkinPicker = flatpickr('.booking-date[name="date_checkin"]', {
      dateFormat: 'd/m/Y',
      minDate: 'today',
      locale: { firstDayOfWeek: 1 },
      disableMobile: true,
      onChange: function (selectedDates) {
        // Ngày checkout phải sau checkin ít nhất 1 ngày
        checkoutPicker.set('minDate', new Date(selectedDates[0].getTime() + 86400000));
      }
    });

    const checkoutPicker = flatpickr('.booking-date[name="date_checkout"]', {
      dateFormat: 'd/m/Y',
      minDate: new Date(today.getTime() + 86400000),
      locale: { firstDayOfWeek: 1 },
      disableMobile: true,
    });
  });
})(jQuery);